require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-state-of-the-art-question-answering-streamlit-huggingface.json") })
        }
      }, "path---posts-state-of-the-art-question-answering-streamlit-huggingface");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-state-of-the-art-question-answering-streamlit-huggingface!./.cache/json/posts-state-of-the-art-question-answering-streamlit-huggingface.json
// module id = 410
// module chunks = 231608221292675